var map = {
	"./1.png": 427,
	"./2.png": 428,
	"./3.png": 429,
	"./4.png": 430,
	"./boat.jpg": 431,
	"./claystapp.png": 432,
	"./cover.jpg": 433,
	"./hero-1.jpg": 434,
	"./hero-2.jpg": 435,
	"./hero-old.jpg": 436,
	"./nora.png": 437,
	"./pool.jpg": 438,
	"./prime.png": 439,
	"./profile.png": 440
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 666;



//////////////////
// WEBPACK FOOTER
// ./src/components/Templates/light/assets/images ^\.\/.*$
// module id = 666
// module chunks = 0